import React from 'react';
import autoBind from 'react-autobind';
import ClassNames from 'classnames';
import _ from 'lodash';

import ContentService from './../../services/ContentService';
import IDVerificationActions from './../../actions/IDVerificationActions.js';
import InlineInfoMessage from './../Common/InlineInfoMessage.jsx';
import InlineInfoButton from './../Common/InlineInfoButton.jsx';
import {Labels} from './../../constants/IDVerificationConstants';

export default class IDVerificationSummary extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            isHelpHidden_verifiedFrom: true
        }
    }
    
    handleClickHelp(model) {
        if (model === 'verifiedFrom') {
            this.setState({ isHelpHidden_verifiedFrom: !this.state.isHelpHidden_verifiedFrom });
        }
    }

    getHelpMessage(helpCopy, model, key) {
        let help = null;
        let content = ContentService.getContent();
        if (helpCopy) {
            help = (
                <div key={'idv__help-' + key} className="verifiedFrom">
                    <InlineInfoButton helpText={content.idVerification.helpCopy[helpCopy]} 
                        isHidden={this.state.isHelpHidden_verifiedFrom} 
                        toggleShowHideHelpText={this.handleClickHelp.bind(this, model) } />
                    <InlineInfoMessage message={content.idVerification.helpCopy[helpCopy]} 
                        isHidden={this.state.isHelpHidden_verifiedFrom} />
                </div>);
        }
        return help;
    }

    getFieldDisplays(fields, docId) {
        let fieldDisplays = [];

        _.each(fields, (f, fieldIdx) => {
            if (f.value) {
                let key = 'docId-' + docId + '__field-' + fieldIdx;
                fieldDisplays.push(
                    <div className="digital-consent-form__fieldset digital-consent-form__marginBottom30 digital-consent-form__${f.model}" key={key}>
                        <div className="form-section">
                            <div className="form-label-section">
                                <label>{f.label}</label>
                                {this.getHelpMessage(f.helpCopy, f.model, key) }
                                </div>
                                <span key={key + '__readOnly'}>{f.value}</span>
                            </div>
                        </div>
                );
            }
        });

        return fieldDisplays;
    }

    editDocument() {
        IDVerificationActions.startEditIDVerificationForm(this.props.docId, this.props.investorId);
    }

    removeDocument() {
        IDVerificationActions.removeIDVerificationForm(this.props.docId, this.props.investorId);
        this.props.updateVerificationDocument();
    }

    render() {
        const docIdOfInvestor = 'investor' + this.props.investorId + '__docId' + this.props.docId;
        const uniqueKey = 'digital-consent-form__' + docIdOfInvestor;
        const Styles = ClassNames('col-xs-10 col-md-12 digital-consent-form', uniqueKey, 'digital-consent-form__readOnlyMode');
        const fields = this.getFieldDisplays(this.props.model.meta, this.props.docId);

        return (
            <div className={Styles}>
                <div className="digital-consent-form__icons">
                    <a className="digital-consent-form__editButton" title="Edit" onClick={this.editDocument }>
                        <i className="icon icon-pencil"></i>
                    </a>
                    <a title="Remove" className="digital-consent-form__removeButton" onClick={this.removeDocument }>
                        <i className="icon icon-cancel"></i>
                    </a>
                </div>
                <div className="form-section">
                    <h4>{Labels.SELECT_DOCUMENT_TYPE_READONLY_LABEL + ': ' + this.props.model.type}</h4>
                </div>
                {fields}
            </div>
        );
    }
}

IDVerificationSummary.propTypes = {
    investorId: React.PropTypes.number.isRequired,
    docId: React.PropTypes.string.isRequired,
    model: React.PropTypes.object.isRequired,
    updateVerificationDocument: React.PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/IDVerification/IDVerificationSummary.jsx